<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/union/:id', query: { id: unionId } }">联盟生态</el-breadcrumb-item>
        <el-breadcrumb-item>研讨沙龙列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="glag_all">
      <div class="title_top_hr">
        <p>
          <i></i>
          <span>研讨沙龙</span>
          <span class="comment_btn" :class="navTop === '最新' ? 'act' : ''" @click="tabClick('最新')">最新</span>
          <span class="comment_btn" :class="navTop === '最热' ? 'act' : ''" @click="tabClick('最热')">最热</span>
        </p>
        <el-divider></el-divider>
      </div>
      <none-view v-if="liveList.length === 0" :login="liveLoad.login" :loading="liveLoad.loading" :data="liveList" :text="liveLoad.text"></none-view>
      <div class="reception_live_list">
        <div v-for="item in liveList" :key="item.id" class="reception_live_item" @click="allJump(item.type, item.list_id, 15, item.is_doing)">
          <div class="reception_live_item_top">
            <p v-if="item.is_doing === 0" class="reception_live_item_top_icon">
              {{item.start_time}} 开始
            </p>
            <p v-if="item.is_doing === 1" class="reception_live_item_top_icon">
              <i class="iconfont icon-zhengzaibofang"></i>
              进行中
            </p>
            <img :src="item.room_img" alt="封面">
          </div>
          <div class="reception_live_item_bottom">
            <dl class="reception_live_info">
              <dt class="reception_live_title">
                <span v-if="item.is_doing === 0" class="reception_live_title_tag">即将开始</span>
                <span v-if="item.is_doing === 1" class="reception_live_title_tag">进行中</span>
                {{item.title}}
              </dt>
              <dd class="reception_live_user">主讲人：{{item.user_name}}</dd>
            </dl>
            <div class="reception_live_list_item_other">
              <div class="reception_lately_other">
                <span v-if="item.is_doing === 0" ><i class="font_i">{{item.sign_count}}</i> 人报名</span>
                <span v-if="item.is_doing === 1" ><i class="font_i">{{item.on_count}}</i> 人在线</span>
                <!-- <el-divider direction="vertical"></el-divider>
                <span><i class="font_i">456</i> 条弹幕</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="liveList.length > 0" class="hr_page lf">
      <page-button :list = "liveList"
      :limit = "liveMorePage.limit"
      @page = "page"
      ref="page"></page-button>
    </div>
  </div>
</template>

<script>
import none from '../Public/none.vue'
import page from '../Public/page.vue'
export default {
  components: {
    noneView: none,
    pageButton: page
  },
  data () {
    return {
      unionId: '', // 联盟id
      navTop: '最新', // a头部导航默认
      liveLoad: {
        login: false,
        loading: true,
        text: '暂无最近直播内容',
        data: []
      },
      liveList: [], // 回顾列表
      liveMorePage: { // 回顾列表加载
        limit: 4,
        page: 1,
        union_id: '', // 联盟id
        sort: 2
      }
    }
  },
  created () {
    this.unionId = this.$route.query.id
    this.getLiveList()
  },
  methods: {
    getLiveList () {
      const vueThat = this
      vueThat.liveMorePage.union_id = vueThat.unionId
      vueThat.myApi.getDiscussLiveList(vueThat.liveMorePage).then((res) => {
        if (res.data.code === 200) {
          vueThat.liveLoad.loading = false
          vueThat.liveList.push(...res.data.data)
        }
      })
    },
    // 头部切换
    tabClick (type) {
      const vueThat = this
      vueThat.liveLoad.loading = true
      vueThat.liveList = []
      if (type === '最新') {
        vueThat.navTop = '最新'
        vueThat.liveMorePage.sort = 2
      } else {
        vueThat.navTop = '最热'
        vueThat.liveMorePage.sort = 1
      }
      vueThat.getLiveList()
    },
    // 跳转
    jump (id, isDoing) {
      let url = ''
      switch (isDoing) {
        case 0:
          url = '/discussLiveDetail/:id'
          break
        case 1:
          url = '/discussLiveDetail/:id'
          break
        case 2:
          url = '/discussVideoDetail/:id'
          break
      }
      const routeData = this.$router.resolve({
        path: url,
        query: { id: id }
      })
      window.open(routeData.href, '_blank')
    },
    // 加载更多
    page (num) {
      this.morePage.page = num
      this.getLivelist()
    },
    // 详情跳转
    allJump (type, id, navId, isDoing) {
      this.mycommon.allJump(this, type, id, navId, isDoing)
    }
  }
}
</script>

<style>
</style>
